import { useEntityFinderContext } from "../context/EntityFinderContext";
import { Checklist } from "@/bryntum-lib/models/Checklist";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";

export const ChecklistTab = () => {
  const { data, handleClose } = useEntityFinderContext();
  const { editorHandler } = useSwivuBryntumContext();
  const checklists = data as Checklist[];

  const handleChecklistClick = (checklist: Checklist) => {
    const entity = checklist.entity;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    editorHandler.openEditor(EDITOR_KEYS.checklistEditor, null, {
      entity,
      checklistId: checklist.id
    }, { by: "recordType", useExisting: true });
    handleClose();
  };

  return (
    <div className="flex flex-col h-full overflow-auto bg-background">
      {checklists.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-muted-foreground p-8 text-center">
          <svg className="w-12 h-12 mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
            />
          </svg>
          <p className="text-sm">No checklists found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {checklists.map((checklist, index) => (
            <div
              key={checklist.id}
              onClick={() => handleChecklistClick(checklist)}
              className={`px-4 py-3 bg-card hover:opacity-90 cursor-pointer transition-all border-b border-border/40 last:border-b-0 rounded-md ${index === 0 ? "border-t-0" : ""}`}
            >
              <div className="font-medium text-foreground line-clamp-1">{checklist.title || "N/A"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
